import { getUser } from 'utils/authService'

export const canEditTask = task => [task.createdBy, task.userId].includes(getUser().id)
